import React from "react";
import ReactDom from "react-dom";
import SavedSearch from "./save-search";

export default class SaveSearchRenderer {
    constructor(container, data) {
        this._container = container;
        this._data = data;
    }

    onClose() {
        ReactDom.unmountComponentAtNode(this._container);
    }

    render() {
        ReactDom.render(<SavedSearch {...this._data} />, this._container);
    }

    destroy() {
        ReactDom.unmountComponentAtNode(this._container);
    }
}